import React from 'react';
import {
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import asyncComponent from './asyncComponent';

export default (data) => {
  const News = asyncComponent(() => import(/* webpackChunkName: 'news' */ './pages/News'));
  const NewsDetail = asyncComponent(() => import(/* webpackChunkName: 'news-detail' */ './pages/News/Detail'));
  const DYNewsDetail = asyncComponent(() => import(/* webpackChunkName: 'dynews-detail' */ './pages/News/DYDetail'));
  const Profile = asyncComponent(() => import(/* webpackChunkName: 'profile' */ './pages/Profile'));
  const Theme = asyncComponent(() => import(/* webpackChunkName: 'theme' */ './pages/Theme'));
  const One = asyncComponent(() => import(/* webpackChunkName: 'one' */ './pages/One'));
  const OneProduct = asyncComponent(() => import(/* webpackChunkName: 'one-product' */ './pages/One/Product'));
  const Product = asyncComponent(() => import(/* webpackChunkName: 'product' */ './pages/Product'));
  const Brand = asyncComponent(() => import(/* webpackChunkName: 'brand' */ './pages/Brand'));
  const SpecialArea = asyncComponent(() => import(/* webpackChunkName: 'profile-special-area' */ './pages/Profile/SpecialArea'));
  const MyPoint = asyncComponent(() => import(/* webpackChunkName: 'profile-my-point' */ './pages/Profile/MyPoint'));
  const SharePoint = asyncComponent(() => import(/* webpackChunkName: 'profile-share-point' */ './pages/Profile/MyPoint/SharePoint'));
  const Invitation = asyncComponent(() => import(/* webpackChunkName: 'profile-invitation' */ './pages/Profile/Invitation'));
  const CouponList = asyncComponent(() => import(/* webpackChunkName: 'profile-copuons' */ './pages/Profile/Coupons'));
  const CouponDetail = asyncComponent(() => import(/* webpackChunkName: 'profile-coupon-detail' */ './pages/Profile/Coupons/Detail'));
  const MyOrderList = asyncComponent(() => import(/* webpackChunkName: 'profile-my-order' */ './pages/Profile/MyOrder'));
  const MyOrderDetail = asyncComponent(() => import(/* webpackChunkName: 'profile-my-order-detail' */ './pages/Profile/MyOrder/Detail'));
  const OfflineOrder = asyncComponent(() => import(/* webpackChunkName: 'profile-my-order-offline' */ './pages/Profile/MyOrder/Offline'));
  const MemberDay = asyncComponent(() => import(/* webpackChunkName: 'profile-member-day' */ './pages/Profile/SpecialArea/MemberDay'));
  const ShareLife = asyncComponent(() => import(/* webpackChunkName: 'profile-share-life' */ './pages/Profile/ShareLife'));
  const MemberRights = asyncComponent(() => import(/* webpackChunkName: 'profile-member-rights' */'./pages/Profile/MemberRights'));
  const Hotel = asyncComponent(() => import(/* webpackChunkName: 'hotel' */ './pages/Hotel'));
  const MyTravel = asyncComponent(() => import(/* webpackChunkName: 'MyTravel' */ './pages/MyTravel'));
  const SeckillNew = asyncComponent(() => import(/* webpackChunkName: 'SeckillNew' */ './pages/SeckillNew'));
  const FamilySubject = asyncComponent(() => import(/* webpackChunkName: 'FamilySubject' */ './pages/FamilySubject'));
  const AppSubject = asyncComponent(() => import(/* webpackChunkName: 'AppSubject' */ './pages/AppSubject'));
  const AppTodaySpecial = asyncComponent(() => import(/* webpackChunkName: 'AppTodaySpecial' */ './pages/AppTodaySpecial'));
  const WelFare = asyncComponent(() => import(/* webpackChunkName: 'WelFare' */ './pages/WelFare'));
  const SecondKillList = asyncComponent(() => import(/* webpackChunkName: 'secondkill' */ './pages/SecondKill'));
  const LastHouse = asyncComponent(() => import(/* webpackChunkName: 'lasthouse' */ './pages/LastHouse'));
  const LastHouseDetail = asyncComponent(() => import(/* webpackChunkName: 'lasthouse-detail' */ './pages/LastHouse/Detail'));
  const Tourism = asyncComponent(() => import(/* webpackChunkName: 'tourism' */ './pages/Tourism'));
  const FirstHouse = asyncComponent(() => import(/* webpackChunkName: 'firsthouse' */ './pages/FirstHouse'));
  const FirstHouseDetail = asyncComponent(() => import(/* webpackChunkName: 'firsthouse-detail' */ './pages/FirstHouse/Detail'));
  const ShareCoupon = asyncComponent(() => import(/* webpackChunkName: 'profile-share-coupon' */ './pages/Profile/ShareCoupon'));
  const OpenCard = asyncComponent(() => import(/* webpackChunkName: 'profile-open-card' */ './pages/Profile/OpenCard'));
  const UserInfo = asyncComponent(() => import(/* webpackChunkName: 'profile-user-info' */ './pages/Profile/UserInfo'));
  const Family = asyncComponent(() => import(/* webpackChunkName: 'family' */ './pages/Family'));
  const FamilyInvitation = asyncComponent(() => import(/* webpackChunkName: 'family-invitation' */ './pages/Family/Invitation'));
  const FamilyProcess = asyncComponent(() => import(/* webpackChunkName: 'family-process' */ './pages/Family/Process'));
  const FamilyJump = asyncComponent(() => import(/* webpackChunkName: 'family-jump' */ './pages/Family/FamilyJump'));
  const Pick = asyncComponent(() => import(/* webpackChunkName: 'pick' */ './pages/Pick'));
  const PickProducts = asyncComponent(() => import(/* webpackChunkName: 'pick-product' */ './pages/Pick/Product'));
  const PayPoint = asyncComponent(() => import(/* webpackChunkName: 'pay-point' */ './pages/PayPoint'));
  const V3Home = asyncComponent(() => import(/* webpackChunkName: 'home' */ './pages/V3Home'));
  const Search = asyncComponent(() => import(/* webpackChunkName: 'search' */ './pages/Search'));
  const SearchPage = asyncComponent(() => import(/* webpackChunkName: 'v3-search' */ './common/V3Search'));
  const Shop = asyncComponent(() => import(/* webpackChunkName: 'shop' */ './pages/Shop'));
  const ShopDetail = asyncComponent(() => import(/* webpackChunkName: 'shop-detail' */ './pages/Shop/Detail'));
  const Other = asyncComponent(() => import(/* webpackChunkName: 'pick-other' */ './pages/Pick/Other'));
  const City = asyncComponent(() => import(/* webpackChunkName: 'city' */ './pages/City'));
  const ProductWrap = asyncComponent(() => import(/* webpackChunkName: 'product-wrap' */ './pages/ProductWrap'));
  const TenPrivilege = asyncComponent(() => import(/* webpackChunkName: 'profile-ten-privilege' */ './pages/Profile/SpecialArea/TenPrivilege'));
  const TenPrivilegeDetail = asyncComponent(() => import(/* webpackChunkName: 'profile-ten-privilege-detail' */ './pages/Profile/SpecialArea/TenPrivilege/Detail'));
  const Privilege = asyncComponent(() => import(/* webpackChunkName: 'profile-privilege' */ './pages/Profile/SpecialArea/Privilege'));
  const MemberMission = asyncComponent(() => import(/* webpackChunkName: 'profile-member-mission' */ './pages/Profile/SpecialArea/MemberMission'));
  const V3Store = asyncComponent(() => import(/* webpackChunkName: 'v3-store' */ './pages/V3Store'));
  const V3StoreDetail = asyncComponent(() => import(/* webpackChunkName: 'v3-store-detail' */ './pages/V3Store/Detail'));
  const TopProduct = asyncComponent(() => import(/* webpackChunkName: 'top-product' */ './pages/TopProduct'));
  const LandingPage = asyncComponent(() => import(/* webpackChunkName: 'landing-page' */ './pages/LandingPage'));
  const ProfileExchange = asyncComponent(() => import(/* webpackChunkName: 'exchange' */ './pages/Profile/Exchange'));
  const JumpToThird = asyncComponent(() => import(/* webpackChunkName: 'jump-to-third' */ './pages/JumpToThird'));
  const Address = asyncComponent(() => import(/* webpackChunkName: 'profile-address' */ './pages/Profile/UserInfo/Address'));
  const EditAddress = asyncComponent(() => import(/* webpackChunkName: 'profile-edit-address' */ './pages/Profile/UserInfo/EditAddress'));
  const FanPai = asyncComponent(() => import(/* webpackChunkName: 'fanpai' */ './pages/FanPai'));
  const FanPaiShare = asyncComponent(() => import(/* webpackChunkName: 'fanpai-share' */ './pages/FanPai/Share'));
  const Rujia = asyncComponent(() => import(/* webpackChunkName: 'activity-rujia' */ './pages/Activity/Rujia'));
  const Agreement = asyncComponent(() => import(/* webpackChunkName: 'activity-rujia-agreement' */ './pages/Activity/Rujia/Agreement'));
  const DoubleFestival = asyncComponent(() => import(/* webpackChunkName: 'activity-double-festival' */ './pages/Activity/DoubleFestival'));
  const MyCoupons = asyncComponent(() => import(/* webpackChunkName: 'profile-my-coupons' */ './pages/Profile/MyCoupons'));
  const MyCouponsDisable = asyncComponent(() => import(/* webpackChunkName: 'profile-my-coupons-detail' */ './pages/Profile/MyCoupons/Disable'));
  const Guide = asyncComponent(() => import(/* webpackChunkName: 'guide' */ './pages/Guide'));
  const GuideList = asyncComponent(() => import(/* webpackChunkName: 'guide-list' */ './pages/Guide/GuideList'));
  const GuideListSearch = asyncComponent(() => import(/* webpackChunkName: 'guide-search' */ './pages/Guide/Search'));
  const GuideStoreList = asyncComponent(() => import(/* webpackChunkName: 'guide-store-list' */ './pages/Guide/StoreList'));
  const GuideBusinessNews = asyncComponent(() => import(/* webpackChunkName: 'guide-business-news' */ './pages/Guide/BusinessNews'));
  const Logistics = asyncComponent(() => import(/* webpackChunkName: 'profile-my-order-logistics' */ './pages/Profile/MyOrder/Logistics'));
  const ReceiveCouponActivity = asyncComponent(() => import(/* webpackChunkName: 'activity-receive-coupon' */ './pages/Activity/ReceiveCoupon'));
  const AllBussiness = asyncComponent(() => import(/* webpackChunkName: 'activity-all-bussiness' */ './pages/Activity/AllBussiness'));
  const UBROrderDetail = asyncComponent(() => import(/* webpackChunkName: 'ubr-order-detail' */ './pages/Profile/MyOrder/UBROrderDetail'));
  const UBRRefundConfirm = asyncComponent(() => import(/* webpackChunkName: 'ubr-refund-confirm' */ './pages/Profile/MyOrder/UBROrderDetail/RefundConfirm'));
  const UBRSelectRefundTicket = asyncComponent(() => import(/* webpackChunkName: 'ubr-select-refund-ticket' */ './pages/Profile/MyOrder/UBROrderDetail/SelectRefundTicket'));
  const CouponProList = asyncComponent(() => import(/* webpackChunkName: 'coupon-product-list' */ './pages/ProductWrap/CouponProList'));
  const PayOrder = asyncComponent(() => import(/* webpackChunkName: 'pay-order' */ './pages/PayOrder'));
  const UbrTheme = asyncComponent(() => import(/* webpackChunkName: 'ubr-theme' */ './pages/Ubr/Theme'));
  const UbrPreOrder = asyncComponent(() => import(/* webpackChunkName: 'ubr-pre-order' */ './pages/Ubr/PreOrder'));
  const UbrHome = asyncComponent(() => import(/* webpackChunkName: 'ubr-home' */ './pages/Ubr/Home'));
  const UbrIntroduction = asyncComponent(() => import(/* webpackChunkName: 'ubr-introduction' */ './pages/Ubr/Introduction'));
  const UbrSpecial = asyncComponent(() => import(/* webpackChunkName: 'ubr-special' */ './pages/Ubr/Special'));
  const JumpToMiniApp = asyncComponent(() => import(/* webpackChunkName: 'jump-to-mini-app' */ './pages/Jump/MiniApp'));
  const UBRBooking = asyncComponent(() => import(/* webpackChunkName: 'ubr-invoice-booking' */ './pages/Ubr/Booking'));
  const PayResult = asyncComponent(() => import(/* webpackChunkName: 'PayResult' */ './pages/PayResult'));
  const PaySuccess = asyncComponent(() => import(/* webpackChunkName: 'PaySuccess' */ './pages/PaySuccess'));
  const PaySuccessOther = asyncComponent(() => import(/* webpackChunkName: 'PaySuccessOther' */ './pages/PaySuccessOther'));
  const UserLogout = asyncComponent(() => import(/* webpackChunkName: 'UserLogout' */ './pages/UserLogout'));
  const PerformanceAreaSelect = asyncComponent(() => import(/* webpackChunkName: 'performance-area-select' */ './pages/Maoyan/Performance/AreaSelcect'));
  const PerformanceSeatSelect = asyncComponent(() => import(/* webpackChunkName: 'performance-seat-select' */ './pages/Maoyan/Performance/SeatSelcect'));
  const PerformanceDamai = asyncComponent(() => import(/* webpackChunkName: 'performance-damai' */ './pages/PerformanceDamai'));
  const HotTopics = asyncComponent(() => import(/* webpackChunkName: 'hotTopics' */ './pages/hotTopics'));
  const InvitationJD = asyncComponent(() => import(/* webpackChunkName: 'InvitationJD' */ './pages/InvitationJD'));
  const InvitationReporterJD = asyncComponent(() => import(/* webpackChunkName: 'Invitation-reporter-JD' */ './pages/InvitationReporterJD'));
  const InvitationGuestJD = asyncComponent(() => import(/* webpackChunkName: 'Invitation-guest-JD' */ './pages/InvitationGuestJD'));
  const PrivacyPolicy = asyncComponent(() => import(/* webpackChunkName: 'PrivacyPolicy' */ './pages/Privacy'));
  const PrivacyPolicyV2 = asyncComponent(() => import(/* webpackChunkName: 'PrivacyPolicyV2' */ './pages/PrivacyV2'));
  const PrivacyDyPolicy = asyncComponent(() => import(/* webpackChunkName: 'PrivacyDyPolicy' */ './pages/PrivacyDy'));
  const RecruitmentActivity = asyncComponent(() => import(/* webpackChunkName: 'RecruitmentActivity' */ './pages/RecruitmentActivity'));
  const PerformanceSeatSelectNew = asyncComponent(() => import(/* webpackChunkName: 'PerformanceSeatSelectNew' */ './pages/Maoyan/Performance/NewSeatSelcect'));
  const NotFound = asyncComponent(() => import(/* webpackChunkName: 'NotFound' */ './pages/NotFound'));

  const MyRedirect = ({ from, to }) => (
    <Route 
      exact 
      path={from} 
      render={({ location, match }) => (
        <Redirect 
          exact 
          from={from} 
          to={{
            pathname: match.params.id ? to +  match.params.id : to,
            search: location.search
          }}
        />
      )}
    />
  );

  const MyRoute = ({ path, component: Component }) => (
    <Route
      path={path}
      render={props => <Component {...props} {...data} />}
    />
  );

  return (
    <div>
      {/* <Footer /> */}
      <Switch>
        <MyRedirect exact from="/" to="/v3home" />
        <MyRedirect from="/home" to="/v3home" />
        <Route
          path='/v3home'
          render={props => <V3Home {...props} initCity={data.getCityList} />}
        />
        <Route
          path='/app/v3home'
          render={props => <V3Home {...props} initCity={data.getCityList} />}
        />

        {/* 旧的app嵌webview的页面 */}
        <MyRedirect from="/app/theme" to="/theme" />
        <MyRedirect from="/app/family" to="/family" />
        <MyRedirect from="/app/tenprivilege" to="/tenprivilege" />
        <MyRedirect from="/app/tenprivilegedetail" to="/tenprivilegedetail" />
        <MyRedirect from="/app/topproduct" to="/topproduct" />
        <MyRedirect from="/app/jumptothird" to="/jumptothird" />
        <MyRedirect from="/app/doublefestival" to="/doublefestival" />

        <MyRedirect from="/app/store/:id" to="/store/" />
        <MyRoute path='/store/:id' component={V3StoreDetail} />

        <Route exact path="/news" component={News} />
        <Route path="/news/:id" component={NewsDetail} />
        <Route path="/app/dynews" component={DYNewsDetail} />
        <Route exact path="/profile" component={Profile} />
        <Route path="/theme" component={Theme} />
        <Route exact path="/one" component={One} />
        <Route path="/one/product" component={OneProduct} />

        {/* v3.1 更新普通产品详情  套包暂不更新 */}
        <Route exact path="/product/1/:id" component={ProductWrap} />
        <Route exact path="/product/2/:id" component={Product} />

        <Route path="/special" component={SpecialArea} />
        <Route path="/brand/:id" component={Brand} />
        <Route path="/mypoint" component={MyPoint} />
        <Route path="/sharepoint" component={SharePoint} />
        <Route path="/invitation" component={Invitation} />
        <Route exact path="/coupons" component={CouponList} />
        <Route path="/coupons/:couponId" component={CouponDetail} />

        {/* 订单 */}
        {/* <MyRedirect from="/app/myorder" to="/myorder" /> */}
        <Redirect exact from="/myorder" to="/my/myorder" />
        <MyRoute exact path="/my/myorder" component={MyOrderList} />
        <Redirect from="/orderdetail/:id/:status" to="/my/orderdetail/:id/:status" />
        <Route path="/my/orderdetail/:id/:status" component={MyOrderDetail} />

        <Route path="/offlineorderdetail/:id" component={OfflineOrder} />
        <Route path="/logistics" component={Logistics} />
        <Route path="/memberday" component={MemberDay} />
        <Route path="/sharelife/:id" component={ShareLife} />
        <Route path="/memberrights" component={MemberRights} />
        <Route path="/hotel/:id" component={Hotel} />
        <Route path="/app/my/mytravel" component={MyTravel} />
        <Route path="/app/seckill/:id" component={SeckillNew} />
        <Route path="/app/my/familysubject" component={FamilySubject} />
        <Route path="/app/appsubject/:id" component={AppSubject} />
        <Route path="/app/apptodayspecial/:homeType/:mkHomeId/:mkHomeModelId" component={AppTodaySpecial} />
        <Route path="/app/welfare" component={WelFare} />
        <Route path="/tourism/:id" component={Tourism} />
        <Route exact path="/firsthouse" component={FirstHouse} />
        <Route path="/firsthouse/:id" component={FirstHouseDetail} />
        <Route exact path="/secondkill" component={SecondKillList} />
        {/* v3.1 产品详情页更新 */}
        <Route path="/secondkill/:id" component={ProductWrap} />
        <Route exact path="/lasthouse" component={LastHouse} />
        <Route path="/lasthouse/:id" component={LastHouseDetail} />
        <Route path="/sharecoupon" component={ShareCoupon} />
        <Route path='/opencard' component={OpenCard} />
        <Route path='/opencardapp' component={OpenCard} />
        <Route path='/userinfo' component={UserInfo} />
        <Route path='/address' component={Address} />
        <Route exact path='/editaddress' component={EditAddress} />
        <Route exact path='/family' component={Family} />
        <Route path='/family/invitation' component={FamilyInvitation} />
        <Route path='/family/process/:type' component={FamilyProcess} />
        <Route path='/family/jump/:uid' component={FamilyJump} />

        <MyRoute exact path='/pick' component={Pick} />
        
        <Route path='/pick/zhu/product' component={PickProducts} />
        <MyRoute path='/paypoint' component={PayPoint} />
        <Route path='/search' component={Search} />
        <Route exact path='/shop' component={Shop} />
        <Route path='/shop/:id' component={ShopDetail} />
        <Route path='/other' component={Other} />
        <Route path='/city' component={City} />
        <Route path='/couponprolist' component={CouponProList} />

        {/* 十大尊享特权 */}
        <Route path='/tenprivilege' component={TenPrivilege} />
        <Route path='/tenprivilegedetail' component={TenPrivilegeDetail} />
        <Route path='/membermission' component={MemberMission} />
        <Route path='/privilege' component={Privilege} />

        <Route path='/productwrap/:id' component={ProductWrap} />

        <Route exact path='/v3store' component={V3Store} />
        <Route path='/v3store/:id' component={V3StoreDetail} />

        {/* 高端产品列表 */}
        <Route path='/topproduct' component={TopProduct} />

        {/* 搜索组件 */}
        <Route
          path='/searchPage/:keyword/:plate'
          render={(props) => (
            <SearchPage {...props} onSearchBack={props.history.goBack} onShow />
      )}
        />

        {/* 配合 3.0  redirect 跳转 */}
        {/* 普通产品 */}
        <Route path="/product/1/1/:id" component={ProductWrap} />
        <Route path="/product/1/2/:id" component={ProductWrap} />
        {/* 套包 */}
        <Route path="/product/2/1/:id" component={Product} />
        {/* 第三方 */}
        <Route path="/product/1/4/:id" component={ProductWrap} />
        {/* 首住 */}
        <Route path="/product/1/3/:id" component={FirstHouseDetail} />
        {/* 尾房 */}
        <Route path="/product/1/5/:id" component={LastHouseDetail} />
        {/* 日历 */}
        <Route path="/product/1/6/:id" component={Hotel} />
        {/* 旅游 */}
        <Route path="/product/1/7/:id" component={Tourism} />
        {/* 商业产品 */}
        <Route path="/product/1/8/:id" component={ProductWrap} />

        <Route path="/homepage/0" component={V3Home} />
        <Route path="/homepage/1" component={Pick} />
        <Route path="/homepage/2" component={PayPoint} />
        <Route path="/homepage/3" component={Profile} />
        
        <Route exact path="/themepage/1" component={SecondKillList} />
        <Route exact path="/themepage/0" component={Theme} />
        {/* 首选付落地页 */}
        <Route exact path="/landingpage" component={LandingPage} />
        {/* 兑换中心 */}
        <Route path="/profile/exchange" component={ProfileExchange} />
        {/* 第三方跳转 */}
        <Route path="/jumptothird" component={JumpToThird} />

        {/* 首旅惠享季 */}
        <Route exact path="/fanpai" component={FanPai} />
        <Route path="/fanpai/share" component={FanPaiShare} />

        {/* 如家落地页 */}
        <Route exact path="/app/rujia" component={Rujia} />
        <Route exact path="/app/rujia/agreement" component={Agreement} />

        {/* 双旦营销页DoubleFestival */}
        <Route path="/doublefestival" component={DoubleFestival} />

        {/* 2020/5/1 领券活动 */}
        <Route path="/app/receive-coupon" component={ReceiveCouponActivity} />

        {/* 外部合租商家聚合页 */}
        <Route path="/app/all-bussiness" component={AllBussiness} />

        {/* 我的优惠券 */}
        <Route exact path="/mycoupons" component={MyCoupons} />
        <Route path="/mycoupons/disable" component={MyCouponsDisable} />
        <Route exact path="/app/mycoupons" component={MyCoupons} />
        <Route path="/app/mycoupons/disable" component={MyCouponsDisable} />

        {/* 导购列表 */}
        <Route exact path="/guide" component={Guide} />
        <Route exact path="/guide/:type" component={Guide} />
        <Route exact path="/guidelist" component={GuideList} />
        <Route path="/guidesearch" component={GuideListSearch} />
        <Route path="/guidelist/storelist" component={GuideStoreList} />
        <Route path="/guide/businessnews/:id" component={GuideBusinessNews} />

        {/* UBR订单详情 */}
        <Route path="/ubr-order-detail/:id/:subId?" component={UBROrderDetail} />
        <Route path="/ubr-select-refund-ticket/:id" component={UBRSelectRefundTicket} />
        <Route path="/ubr-refund-confirm/:id" component={UBRRefundConfirm} />

        {/* 订单确认 */}
        <Route exact path="/payorder" component={PayOrder} />

        {/* ubr 专题页 */}
        <Route exact path="/ubr-theme" component={UbrTheme} />
        <MyRoute exact path="/app/ubr-theme" component={UbrTheme} />
        {/* ubr 下单页 */}
        <MyRoute exact path="/ubr-pre-order/:storeId/:productId/:banner" component={UbrPreOrder} />
        {/* ubr 首页 */}
        <Route exact path="/app/ubr-home" component={UbrHome} />
        {/* ubr 环球IP介绍 */}
        <Route exact path="/app/ubr-introduction/:id" component={UbrIntroduction} />
        {/* ubr 七大主题专区 */}
        <Route exact path="/app/ubr-special/:id" component={UbrSpecial} />
        {/* ubr 环球开票预约页 */}
        <Route path="/ubr-invoice-booking" component={UBRBooking} />
        <Route path="/app/ubr-invoice-booking" component={UBRBooking} />

        {/* 外部浏览器 跳转小程序 */}
        <Route path="/app/jump-mini-app" component={JumpToMiniApp} />

        {/* 外部小程序支付结果页 */}
        <Route path="/app/payresult" component={PayResult} />

        {/* 支付成功页 */}
        <Route path="/paysuccess" component={PaySuccess} />

        {/* 第三方支付成功页 */}
        <Route path="/app/paysuccessother" component={PaySuccessOther} />

        {/* 用户注销 */}
        <Route path="/app/my/userlogout" component={UserLogout} />

        {/* 猫眼 - 演出区域选择 */}
        <Route path="/maoyan/performance/area-select" component={PerformanceAreaSelect} />

        {/* 猫眼 - 演出座位选择 */}
        <Route path="/maoyan/performance/seat-select" component={PerformanceSeatSelect} />
        
        {/* 猫眼 - 演出新接口座位选择 */}
        <Route path="/maoyan/performance/seat-select-new" component={PerformanceSeatSelectNew} />

        {/* 猫眼 - 演出座位选择 */}
        <Route path="/app/hot/:id" component={HotTopics} />

        {/* 大麦 - 座位选择完毕回调 */}
        <Route path="/damai/performance" component={PerformanceDamai} />
        
        {/* 首航邀请函 */}
        <Route path="/app/InvitationJD" component={InvitationJD} />
        {/* 首航邀请函记者版 */}
        <Route path="/app/InvitationReporterJD" component={InvitationReporterJD} />
        {/* 首航邀请函嘉宾版 */}
        <Route path="/app/InvitationGuestJD" component={InvitationGuestJD} />

        {/* 微信隐私政策V1 */}
        <Route path="/app/PrivacyPolicyV1" component={PrivacyPolicy} />
        {/* 微信隐私政策V2 */}
        <Route path="/app/PrivacyPolicy" component={PrivacyPolicyV2} />
        {/* 抖音隐私政策 */}
        <Route path="/app/PrivacyDyPolicy" component={PrivacyDyPolicy} />
        {/* 2959 H5招募活动页 */}
        <Route path="/app/recruitment-activity" component={RecruitmentActivity} />

        <Route component={NotFound} />
      </Switch>
    </div>
  );
};
